<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="close">Copy existing unit</modal-header>
        </div>
        <p>Please enter a new locale</p>
        <div class="form-group">
          <label for="locale">New Locale</label>
          <input type="text" class="form-control" id="locale" v-model="choices.locale">
          <label v-if="this.newLocale" class="error" for="locale">Please enter a different locale from the original</label>
        </div>
        <div slot="modalFooter">
          <modal-footer :closeModal="close" :confirm="confirm" cancelText="Cancel" confirmText="Copy Unit" :confirmDisabled="!isReady"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {modalMixin} from '@/mixins/modalMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_copy_creativeUnit',
  mixins: [modalMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta
  },
  props: {
    show: Boolean,
    confirmId: String,
    locale: String // Original Locale
  },
  data: () => ({
    choices: {
      locale: '', // New locale
      originalId: ''
    }
  }),
  mounted () {},
  computed: {
    isReady () {
      if (this.choices.locale === null || this.choices.locale === '' || this.newLocale) {
        return false
      } else {
        return true
      }
    },
    newLocale () {
      if (this.choices.locale === this.locale) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    confirm () {
      this.choices.originalId = this.confirmId
      this.$emit('confirmCopyUnit', this.choices)
      this.close()
    }
  }
}

</script>

<style lang="scss">
  .error {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/Modal/creatives/modal-copy-creativeUnit.vue